import { render, staticRenderFns } from "./AppLottie.vue?vue&type=template&id=58730bec&scoped=true"
import script from "./AppLottie.vue?vue&type=script&lang=js"
export * from "./AppLottie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58730bec",
  null
  
)

export default component.exports